<template>
    <div class="changeBg">
        <!-- logo -->
        <div class="logo-top">
            <p>纸搬客智能回收机002型</p>
        </div>
        <!-- 型号 -->
        <div class="common-border model">
            <h2>纸搬客智能回收机002型</h2>
            <img src="../assets/img/changeBg/1.png" alt=""  class="animated bounceInUp">
        </div>
        <!-- 转变,岂止于大 -->
        <div class="common-border intelligence">
            <h2 class="common-h2">转变,&nbsp;岂止于大</h2>
            <p>基于纸搬客智能废纸回收机ZBKSZJ001进行的升级改款，在废纸粉碎回收的基础上新设书籍专项投递口，不粉碎，传承才有意义。</p>
            <div class="small" @click="top">向下滑动<img src="../assets/img/changeBg/2.png" alt=""></div>
        </div>
        <!-- 步骤 -->
        <div class="common-border step">
            <div class="step-left">
                <img src="../assets/img/changeBg/3.png" alt="" class="img-1">
            </div>
            <div class="step-center">
                <img src="../assets/img/changeBg/4.png" alt="" class="img-2">
            </div>
            <div class="step-right">
                <img src="../assets/img/changeBg/5.png" alt="" class="img-3">
            </div>
        </div>
        <!-- 有公益才够环保 -->
        <div class="common-border speak">
            <div class="speak-left">
                <h2 class="common-h2">有公益才够环保</h2>
                <p>原有碎纸系统将保留，同时增加书籍投递口，不粉碎也一样的有偿。</p>
            </div>
            <div class="speak-right">
                <img src="../assets/img/changeBg/6.png" alt="">
            </div>
        </div>
        <!-- 改变不止一点 -->
        <div class="common-border just">
            <div class="just-left">
                <img src="../assets/img/changeBg/7.png" alt="">
            </div>
            <div class="just-right">
                <h2 class="common-h2">改变不止一点</h2>
                <p>为适配更个性化的需求，机身进行了加宽加大，储蓄能力加强，不变的就是黄金分割的重量配比，更加安全。如果你愿意，可以叫他"plus"。</p>
            </div>
        </div>
        <!-- 安全更安全 -->
        <div class="common-border safe">
            <h2 class="common-h2">安全更安全</h2>
            <p>双系统交互操作，既保持独立，又融为一体，原有的安全措施全面升级，如果你愿意，可以叫他“哨兵plus”。</p>
            <img src="../assets/img/changeBg/8.png" alt="">
        </div>
        <!-- 看不见也一样安全 -->
        <div class="common-border speak-com">
            <div class="speak-left-com">
                <h2 class="common-h2">看不见也一样安全</h2>
                <p>设备指示灯及安全home键隐藏，更智能的“哨兵”可完成此项工作。</p>
            </div>
            <div class="speak-right-com">
                <img src="../assets/img/changeBg/9.png" alt="">
            </div>
        </div>
        <!-- 更大更不怕 -->
        <div class="common-border windRain">
            <div class="windRain-left">
                <img src="../assets/img/changeBg/10.png" alt="">
            </div>
            <div class="windRain-right">
                <h2 class="common-h2">更大更不怕</h2>
                <p>加大外置挡雨顶棚，机身材料进一步升级，雨水只会让它更白净。纸搬客设备正视图，背后水花。</p>
            </div>
        </div>
        <div class="common-border strong">
            <h2 class="common-h2">无需多言的配置</h2>
            <ul class="strong-last">
                <li>
                    <img src="../assets/img/changeBg/11.png" alt="" class="img-4">
                    <h3>plus金属机身</h3>
                    <p>伟岸更加靠得住</p>
                </li>
                <li>
                    <img src="../assets/img/changeBg/12.png" alt="" class="img-5">
                    <h3>基站+WiFi定位</h3>
                    <p>1+1，何止等于2</p>
                </li>
                <li>
                    <img src="../assets/img/changeBg/13.png" alt="" class="img-6">
                    <h3>220V弱电驱动</h3>
                    <p>加大机身耗能不变</p>
                </li>
                <li>
                    <img src="../assets/img/changeBg/14.png" alt="" class="img-7">
                    <h3>断电保护</h3>
                    <p>不只是快，碎纸中断电将上报数据于<br>后台，保护性强，才称得上有偿</p>
                </li>
                <li>
                    <img src="../assets/img/changeBg/15.png" alt="" class="img-8">
                    <h3>远程交互</h3>
                    <p>设备将和纸搬客后台保持通讯<br>远程交互，既是智能，更是安全</p>
                </li>
                <li>
                    <img src="../assets/img/changeBg/16.png" alt="" class="img-9">
                    <h3>系统升级</h3>
                    <p>内置纸搬客自研回收系统，定期进行系<br>统升级，软硬结合，才是物联
                    </p>
                </li>
            </ul>
        </div>
         <!-- 1+1，才更环保 拷贝 -->
         <div class="common-border environmental">
            <div class="environmental-left">
                <h3>1+1，才更环保</h3>
                <h2>纸搬客智能回收机002型</h2>
            </div>
            <div class="environmental-right">
                <img src="../assets/img/changeBg/1.png" alt="">
            </div>
        </div>
        <footer_s></footer_s>
    </div>
</template>
<script>
    import $ from 'jquery'
    import footer_s from './common/footer'
    export default {
        components:{
            footer_s,
        },
        data() {
            return {}
        },
        methods:{
            top(){
                var scrollT=$(window).scrollTop(); //滚动的高度
                $(document).scrollTop(scrollT+120);
            }
        },
        mounted(){
            $(function(){
                $('.model h2').animate({
                    opacity: 1
                }, 2000)
                $(window).scroll(function(){
                    var scrollT=$(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var ModelHeight = $('.model').offset().top; //元素的高度
                    var intelligenceHeight=$('.intelligence').offset().top;
                    var StepHeight=$('.step').offset().top;
                    var SpeakHeight=$('.speak').offset().top;
                    var JustHeight=$('.just').offset().top;
                    var SafeHeight=$('.safe').offset().top;
                    var SpeakCHeight=$('.speak-com').offset().top;
                    var noSpeakHeight=$('.windRain').offset().top;
                    var strongHeight=$('.strong').offset().top;
                    var environmentalHeight=$('.environmental').offset().top;
                    if (scrollT + ViewHeight >= intelligenceHeight) {
                        $('.intelligence h2,.intelligence p').animate({
                            opacity: 1
                        }, 4000)
                    } 
                    if (scrollT + ViewHeight >= StepHeight) {
                        $('.step-left img').addClass('animated fadeInLeftBig')
                        $('.step-center img').addClass('animated fadeInUpBig')
                        $('.step-right img').addClass('animated fadeInRightBig')
                    }
                    if (scrollT + ViewHeight >= SpeakHeight) {
                        $('.speak-right img').addClass('animated fadeInRightBig')
                        $('.speak-left h2,.speak-left p').addClass('animated fadeInLeftBig').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= JustHeight) {
                        $('.just-left img').addClass('animated zoomInLeft')
                        $('.just-right h2,.just-right p').addClass('animated zoomInRight').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= SafeHeight) {
                        $('.safe h2,.safe p').animate({
                            opacity: 1
                        }, 3000)
                        $('.safe img').addClass('animated fadeInUp')
                    }
                    if (scrollT + ViewHeight >= SpeakCHeight) {
                        $('.speak-right-com img').addClass('animated bounceInRight')
                        $('.speak-left-com h2,.speak-left-com p').addClass('animated bounceInLeft').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= noSpeakHeight) {
                        $('.windRain-left img').addClass('animated bounceInLeft')
                        $('.windRain-right h2,.windRain-right p').addClass('animated bounceInRight').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= strongHeight) {
                        $('.strong-last li:nth-of-type(1),.strong-last li:nth-of-type(4)').addClass('animated bounceInLeft')
                        $('.strong-last li:nth-of-type(2),.strong-last li:nth-of-type(5)').addClass('animated bounceInUp')
                        $('.strong-last li:nth-of-type(3),.strong-last li:nth-of-type(6 )').addClass('animated bounceInRight')
                        $('.strong h2').addClass('animated zoomInLeft').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= environmentalHeight) {
                        $('.environmental-right img').addClass('animated zoomInLeft')
                        $('.environmental-left h2,.environmental-left h3').addClass('animated zoomInRight').animate({
                            opacity: 1
                        }, 2000)
                    }
                })
            })
        },
        beforeDestroy(){
            $(window).off('scroll');
        }
    }
</script>
<style scoped>
    .changeBg {
        width: 100%;
        height: 100%;
    }

    .logo-top {
        width: 100%;
        height: 0.18rem;
        background:rgba(255,255,255,1);
    }

    .logo-top p {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color:rgba(55,55,55,1);
        line-height: 0.18rem;
        margin-left: 0.7rem;
    }

    .common-border {
        border-left: 0.08rem solid #F5F5F7;
        border-right: 0.08rem solid #F5F5F7;
        border-bottom: 0.12rem solid #F5F5F7;
    }

    .model {
        position: relative;
        height: 1.94rem;
        padding-top: 0.14rem;
        background-color: #F5F5F7;
    }

    .model h2 {
        font-size: 0.16rem;
        text-align: center;
        font-weight: bold;
        font-family: Microsoft YaHei;
        color: rgba(55, 55, 55, 1);
        opacity: 0.3;
    }

    .model img {
        width: 1.21rem;
        height: 1.43rem;
        position: absolute;
        top: 0.43rem;
        left: 50%;
        margin-left: -0.605rem;
    }

    .intelligence {
        height: 1.94rem;
        padding-top: 0.42rem;
        background-color: #fff;
    }

    .intelligence h2 {
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        text-align: center;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        margin-bottom: 0.11rem;
        opacity: 0.3;
    }

    .intelligence p {
        font-size: 0.07rem;
        font-family: PingFang SC;
        font-weight: Bold;
        text-align: center;
        line-height: 0.11rem;
        color: rgba(55, 55, 55, 1);
        padding: 0 1.03rem;
        opacity: 0.3;

    }

    .intelligence .small {
        width: 0.69rem;
        height: 0.18rem;
        border: 0.005rem solid rgba(55, 55, 55, 1);
        border-radius: 0.03rem;
        margin: 0 auto;
        margin-top: 0.14rem;
        font-size: 0.09rem;
        font-family: PingFang SC;
        color: rgba(55, 55, 55, 1);
        text-align: center;
        line-height: 0.15rem;
    }

    .small img {
        width: 0.09rem;
        height: 0.07rem;
        vertical-align: middle;
        margin-left: 0.07rem;
    }

    .step {
        height: 1.94rem;
        background-color: #F5F5F7;
    }

    .step-left,
    .step-center,
    .step-right {
        width: 31%;
        height: 1.82rem;
        float: left;
        margin-right: 3.5%;
        background: #ffffff;
        position: relative;
    }

    .step-right {
        margin-right: 0;
    }

    .step-left .img-1 {
        width: 0.99rem;
        height: 1.17rem;
        position: absolute;
        left: 50%;
        margin-left: -0.495rem;
        top: 0.34rem;
    }

    .step-center .img-2 {
        width: 0.92rem;
        height: 0.67rem;
        position: absolute;
        left: 50%;
        margin-left: -0.46rem;
        top: 0.52rem;
    }

    .step-right .img-3 {
        width: 0.85rem;
        height: 1.35rem;
        position: absolute;
        left: 50%;
        margin-left: -0.425rem;
        top: 0.26rem;
    }

    .speak,
    .just,.speak-com {
        overflow: hidden;
        height: 1.94rem;
        background-color: #F5F5F7;
    }

    .speak-left,
    .just-right,.speak-left-com {
        width: 51%;
        height: 1.82rem;
        padding-top: 0.6rem;
        float: left;
        margin-right: 3%;
        background-color: #fff;
    }

    .speak-left h2,.speak-left-com h2 {
        color:rgba(55,55,55,1);
        font-size: 0.15rem;
        margin-bottom: 0.11rem;
        text-align: center;
        opacity: 0.3;

    }

    .speak-left p,.speak-left-com p {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        color: rgba(55, 55, 55, 1);
        text-align: center;
        line-height: 0.12rem;
        font-weight: bold;
        opacity: 0.3;

        padding: 0 0.23rem;
    }

    .speak-right,
    .just-left,.speak-right-com {
        width: 46%;
        height: 1.82rem;
        float: left;
        background-color: #fff;
        position: relative;
    }

    .speak-right img,.speak-right-com img {
        width: 1.1rem;
        height: 1.26rem;
        position: absolute;
        top: 0.25rem;
        left: 50%;
        margin-left: -0.55rem;
    }

    .just-left img {
        width: 1.24rem;
        height: 1.46rem;
        position: absolute;
        top: 0.19rem;
        left: 50%;
        margin-left: -0.62rem;
    }

    .just-left {
        margin-right: 3%;
    }

    .just-right {
        margin-right: 0;
    }

    .just-right h2 {
        color:rgba(55,55,55,1);
        font-size: 0.16rem;
        text-align: center;
        margin-bottom: 0.11rem;
        opacity: 0.3;

    }

    .just-right p {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.12rem;
        text-align: center;
        padding: 0 0.08rem;
        opacity: 0.3;

    }

    .safe {
        height: 1.94rem;
        position: relative;
        background-color: #fff;
        padding-top: 0.1rem;
    }

    .safe h2 {
        color:rgba(55,55,55,1);
        font-size: 0.16rem;
        margin: 0 0 0.05rem 0;
        text-align: center;
        opacity: 0.3;

    }

    .safe p {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        color: rgba(55, 55, 55, 1);
        text-align: center;
        font-weight: bold;
        padding: 0 1rem;
        line-height: 0.12rem;
        opacity: 0.3;

    }

    .safe img {
        width: 1.97rem;
        height: 1.11rem;
        position: absolute;
        top: 0.66rem;
        left: 50%;
        margin-left: -0.985rem;
    }

    .windRain,.environmental {
        overflow: hidden;
        height: 1.94rem;
        background-color: #fff;
    }

    .windRain-left,.environmental-left {
        width: 58%;
        height: 1.82rem;
        float: left;
        position: relative;
    }
    .environmental-left h2{
        font-size:0.17rem;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(55,55,55,1);
        margin-left: 0.23rem;
        opacity: 0.3;
    }
    .environmental-left h3{
        font-size:0.14rem;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(55,55,55,1);
        line-height:0.3rem;
        margin: 0.69rem 0 0 0.2rem;
        opacity: 0.3;
    }

    .windRain-left img {
        width: 2.12rem;
        height: 1.51rem;
        position: absolute;
        top: 0.37rem;
        left: 0;
    }

    .windRain-right,.environmental-right {
        width: 42%;
        height: 1.94rem;
        float: left;
        position: relative;
    }
    .environmental-right img{
        width: 1.21rem;
        height: 1.43rem;
        position: absolute;
        bottom: 0.12rem;
        right: 0.24rem;
    }
    .windRain-right h2 {
        color:rgba(55,55,55,1);
        letter-spacing: 0.01rem;
        font-size: 0.15rem;
        margin: 0.37rem 0 0.1rem 0;
        text-align: center;
        opacity: 0.3;

    }

    .windRain-right p {
        /* margin: 0 0.07rem 0 0.07rem; */
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        color: rgba(55, 55, 55, 1);
        line-height: 0.12rem;
        text-align: center;
        font-weight: bold;
        padding: 0 0.06rem;
        opacity: 0.3;

    }

    .strong {
        height: 1.94rem;
        background-color: #fff;
        padding-top: 0.1rem;
        color:rgba(55,55,55,1);
    }

    .strong h2 {
        font-size: 0.2rem;
        margin: 0 0 0.15rem 0.10rem;
        opacity: 0.3;
    }

    .strong-last {
        overflow: hidden;
    }

    .strong-last li {
        width: 30.3%;
        min-height: 0.6rem;
        float: left;
        padding-left: 2%;
        margin-left: 3%;
    }

    .strong-last li:nth-child(3) {
        margin-right: 0;
    }

    .strong-last li img {
        vertical-align: middle;
    }

    .img-4 {
        width: 0.15rem;
        height: 0.16rem;
        margin-bottom: 0.08rem;
    }

    .img-5 {
        width: 0.12rem;
        height: 0.12rem;
        margin-bottom: 0.11rem;
    }

    .img-6 {
        width: 0.11rem;
        height: 0.13rem;
        margin-bottom: 0.11rem;
    }

    .img-7 {
        width: 0.14rem;
        height: 0.14rem;
        margin: 0.07rem 0 0.1rem 0;
    }

    .img-8 {
        width: 0.11rem;
        height: 0.1rem;
        margin: 0.11rem 0 0.1rem 0;
    }

    .img-9 {
        width: 0.1rem;
        height: 0.1rem;
        margin: 0.11rem 0 0.1rem 0;
    }

    .strong-last li h3 {
        font-size: 0.06rem;
        font-family: PingFang SC;
        color: rgba(55, 55, 55, 1);
        margin-bottom: 0.03rem;
    }

    .strong-last li p {
        font-size: 0.05rem;
        font-family: PingFang SC;
        color: rgba(122, 122, 122, 1);
        line-height: 0.06rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/views/two.vue